let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5PueW")).then(() => parcelRequire('c8qbu'));